function init() {
	var $tip = $('[data-tip]');

	if(!$tip.length) return;

	$tip.each(function() {
		var $this = $(this);
		$this.addClass('tooltip');
		$this.append('<span class="tooltip-item">'+$this.attr('data-tip')+'</span>');
	});
}

$(function() {
	init();
})